export default __webpack_public_path__ + "static/contact-banner-582938b7d2017173766238ab596452cb.jpg";